
<p-steps [model]="items" [(activeIndex)]="activeIndex" [readonly]="true">
</p-steps>

<app-criar-oscliente     *ngIf="activeIndex == 0"  (messageEvent)="selecionarCliente($event)" ></app-criar-oscliente>
<app-criar-osativo       *ngIf="activeIndex == 1"  (messageEvent)="selecionarAtivo($event)"></app-criar-osativo>
<app-criar-osendereco    *ngIf="activeIndex == 2"  (messageEvent)="selecionarEndereco($event)"></app-criar-osendereco>
<app-criar-osambiente    *ngIf="activeIndex == 3"  (messageEvent)="selecionarAmbiente($event)"></app-criar-osambiente>
<app-criar-ostipo-os     *ngIf="activeIndex == 4"  (messageEvent)="selecionarTipoOS($event)"></app-criar-ostipo-os>
<app-criar-osanexo     *ngIf="activeIndex == 5"  (messageEvent)="selecionarAnexos($event)"></app-criar-osanexo>
<app-criar-osconfirmacao *ngIf="activeIndex == 6"></app-criar-osconfirmacao>

<adv-growl></adv-growl>
<div class="ui-g-9" style="margin-left: 14%;">
    <div class="ui-g-6 ui-md-1">
        <button pButton icon="fa fa-arrow-circle-left"
                iconPos="left"
                *ngIf="isVisible"
                (click)="previous()"
                i18n-label
                label="Anterior"></button>
    </div>
    <div class="ui-g-4 ui-md-1 ui-md-offset-9">
        <button pButton icon="fa fa-arrow-circle-right"
                iconPos="right"
                *ngIf="activeIndex != 6"
                (click)="next()"
                i18n-label
                label="Próximo"></button>
    </div>
    <div class="ui-g-4 ui-md-1 ui-md-offset-9">
        <ngx-ui-loader></ngx-ui-loader>
        <button pButton icon="fa fa-check" style="bottom: 15px;"
                (click)="confirmar()"
               *ngIf="activeIndex == 6"
                class="ui-button-success"
                [disabled]="isDisabled"
                i18n-label
                label="Confirmar"></button>
    </div>
</div>

